<template>
  <h4 class="money">
    <small style="font-weight: 100; margin-right: -4px">₦</small>
    {{ amount }}
    <small style="font-weight: 100; margin-left: -4px">.{{ decimal }}</small>
  </h4>
</template>

<script>
import { formatMoney } from "@/utils/helpers";
export default {
  name: "money",
  props: {
    value: {
      default: ""
    }
  },
  data() {
    return {
      amount: "",
      decimal: ""
    };
  },
  created() {
    const temp = formatMoney(this.value).split(".");
    this.amount = temp[0].substr(1);
    this.decimal = temp[1];
  }
};
</script>
<style lang="scss" scoped>
h4.money {
  font-weight: bold;
  font-size: 1.5rem;
}
@media (max-width: 768px) {
  h4.money {
    font-size: 1.2rem;
  }
}
</style>
